import SuggestedActionSection from './SuggestedActionSection.component';

export default SuggestedActionSection;
